module.exports = __webpack_public_path__ + "img/qcyn-titile-bg.43ef2456.png";